import { ENV } from './env';

export const API_DOMAINS = {
	GET_USER_DATA: 'https://www.iplocate.io/api/lookup/',
	SEND_USER_DATA: `${ENV.API_LIFT_STORY_URL}/addition-user-data/web`,
	SEND_WEB_PIXEL_DATA: `${ENV.API_LIFT_STORY_URL}/log/web-pixel-event`,
	GET_USER_CURRENCY_INFO: `${ENV.API_LIFT_STORY_URL}/user/currency`,
	UPLOAD_IMAGE: `${ENV.API_LIFT_STORY_URL}/v4/image-services/upload-data`,
	UPLOAD_VIDEO_MULTIPART: `${ENV.API_LIFT_STORY_URL}/v1/temp-data/multipart-upload`,
	GET_LANDING_SPLIT_TESTS: `${ENV.API_LIFT_STORY_URL}/liftapp-web/split-tests`,
	GET_PAYWALL_CONFIG: `${ENV.API_LIFT_STORY_URL}/v1/config/paywall`,
	GET_IMAGE_GEN_MODELS: `${ENV.API_LIFT_STORY_URL}/v4/image-generation/models`,
	GET_VIDEO_GEN_MODELS: `${ENV.API_LIFT_STORY_URL}/v3/ai-text-to-video/models`,
} as const;
